import { FC } from 'react';
import { IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle } from '@ionic/react';
import { AllieCardProps } from './Card.types';
import { StyledCard } from './Card.styles';

export const AllieCard: FC<AllieCardProps> = ({
  allieColor = 'neutral',
  header,
  title,
  subtitle,
  content,
  footer,
  ...props
}) => (
  <StyledCard allieColor={allieColor} {...props}>
    {header && <IonCardHeader {...header} />}
    {!header && (title || subtitle) && (
      <IonCardHeader>
        {title && <IonCardTitle {...title} />}
        {subtitle && <IonCardSubtitle {...subtitle} />}
      </IonCardHeader>
    )}
    {content && <IonCardContent {...content} />}
    {footer && <IonCardHeader {...footer} />}
  </StyledCard>
);
